import { render } from "./AccessEditIFrame.vue?vue&type=template&id=62a66e5c&ts=true"
import script from "./AccessEditIFrame.ts?vue&type=script&lang=ts&external"
export * from "./AccessEditIFrame.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__